import React, { useState, useEffect } from "react";
import BreadCrumbComponent from "./BreadCrumb";
import { Row, Col, Typography, Button, Form, message, Upload } from "antd";
import UploadImages from "./UploadImages";
import StepsComponent from "./StepsComponent";
import API_KEY from "../../../api/index";
import ImageUploadModal from "./ImageUploadModal";
import { useParams, useHistory } from "react-router-dom";
import axios from "axios";
import VariantModal from "./Variant/index";

const { Title } = Typography;
let isSubCatPresent; 

function getOtherAttributes(attributes = []) {
  return attributes.reduce((acc, attribute, currentIndex) => {
    const key = `${
      attribute?.attribute_values_id?.attribute_id?.name || attribute?.name
    }:${attribute?.attribute_values_id?.attribute_id?.id || attribute?.id}`;
    const value = attribute?.attribute_values_id?.values || attribute?.values;
    const composite =
      attribute?.attribute_values_id?.composite || attribute?.composite;
    if (
      attribute?.attribute_values_id?.attribute_id?.dtype === "csv" ||
      attribute?.dtype === "csv"
    ) {
      return {
        ...acc,
        [key]: value && value?.length > 0 ? value.split(",") : [],
      };
    }
    if (
      attribute?.attribute_values_id?.attribute_id?.dtype === "price" ||
      attribute?.dtype === "price"
    ) {
      return {
        ...acc,
        [key]: value,
        [`${key}:currency`]: composite?.currency,
        [`${key}:unit`]: composite?.unit,
      };
    }
    if (
      attribute?.attribute_values_id?.attribute_id?.dtype === "size" ||
      attribute?.dtype === "size"
    ) {
      return {
        ...acc,
        [key]: value,
        [`${key}:length`]: composite?.length,
        [`${key}:width`]: composite?.width,
        [`${key}:height`]: composite?.height,
        [`${key}:unit`]: composite?.unit,
      };
    }
    return { ...acc, [key]: value };
  }, {});
}

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
function beforeUpload(file) {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("You can only upload JPG/PNG file!");
  }
  return isJpgOrPng;
}

export default function AddNewProduct({ page, formData, initalCategoryData }) {
  const [hideInfo, setHideInfo] = useState(true);
  const [showTooltipOnFinish, setTooltipOnFinish] = useState(true);
  const [current, setCurrent] = useState("1");
  const [allCategoryData, setAllCategoryData] = useState(null);
  const [categoryData, setCategoryData] = useState(initalCategoryData);
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [photoList, setphotoList] = useState([]);
  const [previewTitle, setPreviewTitle] = useState("");
  const history = useHistory();
  const params = useParams();
  const [progress, setProgress] = useState(0);
  const [progressData, setProgressData] = useState({});
  const [error, setError] = useState(null);
  const [loadingFinishButton, setLoadingFinishButton] = useState(false);
  const [showVariantModal, setShowVariantModal] = useState(false);
  const [variantsData, setVariantsData] = useState(null);
  const [variantsCount, setVariantsCount] = useState(0);
  const [productId, setProductId] = useState(null);
  const [categoryId, setCategoryId] = useState(null);
  const [subcategory, setSubCategory] = useState(null);
  const [productData, setProductData] = useState(null);
  const [files, setFiles] = useState(null);
  const [showVendorDetails, setVendorDetailsButton] = useState(false);
  const [sizeUnit, setSizeUnit] = useState({});
  const [showExclusiveDetails, setExclusiveDetailsButton] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    checkMandatoryFields();
  }, [photoList]);

  useEffect(() => {
    if (formData) {
      formData?.attributes &&
        setFiles(
          formData?.attributes.filter(
            (attribute) =>
              attribute?.attribute_values_id?.attribute_id?.dtype === "file"
          )
        );
      setProductData(formData);
    }
  }, [formData]);

  useEffect(() => {
    if (page === "edit" && productData) {
      setHideInfo(false);
      setphotoList(productData.product_images);
      setProductId(productData?.product_id);
      setCategoryId(productData.secondary_category.id);
      setSubCategory(productData?.sub_category);
      form.setFieldsValue({
        product_id: productData?.product_id,
        secondary_category: productData?.secondary_category.id,
        sub_category:
          productData?.sub_category?.length > 0
            ? productData?.sub_category
            : [],
        ...getOtherAttributes(productData?.attributes),
      });

      setDefaultSizeUnits(productData?.attributes);
      if (
        productData?.attributes?.some(
          (attr) =>
            (attr.attribute_values_id?.attribute_id?.is_internal === true &&
              attr?.attribute_values_id?.values &&
              attr.attribute_values_id?.attribute_id?.tabname === "vendor") ||
            (attr?.is_internal === true &&
              attr?.values &&
              attr?.tabname === "vendor")
        )
      ) {
        setVendorDetailsButton(true);
      }

      if (
        productData?.attributes?.some(
          (attr) =>
            (attr.attribute_values_id?.attribute_id?.is_internal === true &&
              attr?.attribute_values_id?.values &&
              attr.attribute_values_id?.attribute_id?.tabname ===
                "exclusive") ||
            (attr?.is_internal === true &&
              attr?.values &&
              attr?.tabname === "exclusive")
        )
      ) {
        setExclusiveDetailsButton(true);
      }

      setTooltipOnFinish(false);
    } else if (page === "productByCategory") {
      setHideInfo(false);
      setCategoryId(formData.secondary_category_id);
      form.setFieldsValue({
        secondary_category: formData.secondary_category_id,
      });
    }

    if (productData?.variants?.length > 0) {
      setVariantsCount(productData?.variants?.length);
    }
  }, [productData]);

  useEffect(() => {

    isSubCatPresent= JSON.parse(localStorage.getItem("pref"))? JSON.parse(localStorage.getItem("pref"))?.sub_category : false;
    setLoading(true);
    API_KEY.URL.get(`${API_KEY.path.manufacturer_secondary_category}`, {
      params: {
        fields: "secondary_category_id.*",
        limit:-1,
      },
    }).then((response) => {
      setLoading(false);
      setAllCategoryData(response?.data?.data);
      getCategoryData();

      setHideInfo(false);
    });
  }, [form]);

  useEffect(() => {
    let totalProgress = 0;
    let totalCount = 0;
    for (let imageFileId in progressData) {
      let p = progressData[imageFileId];
      if (p > 0) {
        totalProgress = totalProgress + p;
        totalCount = totalCount + 1;
      }
    }
    const reultantProgress =
      totalCount === 0 ? 0 : Math.floor(totalProgress / totalCount);
    if (reultantProgress === 100) setTimeout(() => setProgressData({}), 1000);
    setProgress(reultantProgress);
  }, [progressData]);

  const setDefaultSizeUnits = (attributes) => {
    const units = {};
    attributes.forEach((attribute) => {
      if (attribute?.attribute_values_id?.attribute_id?.dtype === "size") {
        const keyName = `${attribute?.attribute_values_id?.attribute_id.name}:${attribute?.attribute_values_id?.attribute_id.id}`;
        const value = attribute?.attribute_values_id?.values;
        const composite = attribute?.attribute_values_id?.composite;
        units[keyName] = composite?.unit;
        // setSizeUnit((state) => {
        //   return {
        //     ...state,
        //     keyName:
        //   };
        // });
      }
      setSizeUnit(units);
    });
  };

  // let keyName = `${attribute?.attribute_values_id?.attribute_id?.name}:${attribute?.attribute_values_id?.attribute_id?.id}`;

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
    setPreviewVisible(true);
    setPreviewImage(file.url || file.preview);
  };

  const uploadImage = async (options) => {
    const { onSuccess, onError, file, onProgress } = options;

    const fmData = new FormData();
    const config = {
      headers: { "content-type": "multipart/form-data" },
      onUploadProgress: (event) => {
        const percent = Math.floor((event.loaded / event.total) * 100);
        setProgressData((prevState) => {
          return { ...prevState, [options.file.uid]: percent };
        });
        // if (percent === 100) {
        //   setTimeout(() => setProgressData((prevState) => {
        //     return {...prevState, [options.file.uid]: percent};
        //   }), 1000);
        // }
        onProgress({ percent: (event.loaded / event.total) * 100 });
      },
    };
    fmData.append("image", file);

    axios
      .post(process.env.REACT_APP_ARTIFACTS, fmData, config)
      .then((response) => {
        if (response.status === 200) {
          file.thumbUrl = `${process.env.REACT_APP_DIRECTUS}assets/${response.data?.data?.id}?fit=cover&width=200&height=200&quality=80`;

          onSuccess("Ok");
          setphotoList((result) => [
            ...result,
            {
              directus_files_id: response.data?.data?.id,
              uid: file.uid,
            },
          ]);
        }
      })
      .catch((err) => {
        setError("Something went wrong");
        onError({ err });
      });
  };

  const handleChangeUpload = (info) => {
    setFileList(info.fileList);
    setIsModalVisible(true);
    if (info.file.status === "uploading") {
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj);
    }
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  function fieldSorter(fields) {
    return function (a, b) {
      return fields
        .map(function (o) {
          var dir = 1;
          if (o[0] === "-") {
            dir = -1;
            o = o.substring(1);
          }
          if (a[o] > b[o]) return dir;
          if (a[o] < b[o]) return -dir;
          return 0;
        })
        .reduce(function firstNonZeroValue(p, n) {
          return p ? p : n;
        }, 0);
    };
  }

  const getCategoryData = () => {
    API_KEY.URL.get(`${API_KEY.path.attributes}`, {
      params: {
        fields: "*,attributes.attributes_id.*",
      },
    })
      .then((res) => {
        var tab_keys = {
          production: 0,
          internal: 1,
          vendor: 2,
          exclusive: 3,
          production_detail: 4,
        };
        var attributes = res?.data?.data.map(function (e) {
          e.sorter = tab_keys[e.tabname];
          e.priority = e.priority;
          //console.log(e.sorter);
          return e;
        });

        attributes.sort(fieldSorter(["sorter", "-priority"]));
        res.data.data.attributes = attributes;
        setCategoryData(res?.data?.data);
      })
      .catch((error) => console.log(error));
  };

  const getNewCategoryProductData = (id) => {
    const user = JSON.parse(localStorage.getItem("user"));
    axios
      .post(
        `${process.env.REACT_APP_API_SERVICE}items/productsv2/mock_patch-product-category?id=${productData?.id}&token=${user?.access_token}&categoryId=${id}`,
        {}
      )
      .then((res) => {
        setProductData(res.data);
        setFiles(
          res.data?.attributes.filter(
            (attribute) =>
              attribute?.attribute_values_id?.attribute_id?.dtype === "file"
          )
        );
      })
      .catch((err) => {
        console.log("err:", err);
      });
  };

  const checkMandatoryFields = () => {
    if (photoList?.length > 0 && showTooltipOnFinish === true)
      setTooltipOnFinish(false);
    else if (showTooltipOnFinish === false && !(photoList?.length > 0)) {
      setTooltipOnFinish(true);
    }
  };

  const onChangeField = () => {
    // if (e?.target?.value || e) {
    const { secondary_category } = form.getFieldsValue();
    if (secondary_category) {
      setHideInfo(false);
    } else {
      setHideInfo(true);
    }
    //}
  };

  const tabChange = (key) => {
    setCurrent(key);
  };

  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };
  const next = () => {
    if (current === "1") {
      setCurrent("2");
    }
  };

  const handleClick = (e) => {
    setCurrent(e?.key);
  };

  const onFinish = (values) => {
    // console.log("values", values);
    var userId = localStorage.getItem("userId");
    var org = localStorage.getItem("org");
    const orgId = JSON.parse(org).id;
    let attributes = [];
    let editAttribute = [];
    setLoadingFinishButton(true);
    //modify values object to match the attributes table
    for (const [key, value] of Object.entries(values)) {
      // key contains the id of the attribute

      if (key.includes(":")) {
        //get id of the attribute
        const splitKeys = key.split("--") || [];
        const attributeKey = splitKeys?.[0];
        const parent = attributeKey.split(":")?.[0];
        const attribute = attributeKey.split(":")?.[1];
        // get name of the composite attribute
        const composite = attributeKey.split(":")?.[2];
        const dtype = splitKeys?.[1] || "";

        // check if attribute is already in the attributes array
        const findIndex = attributes.findIndex(
          (item) => item.attribute_values_id.attribute_id === attribute
        );

        if (composite) {
          // if composite attribute is found push the value to the attribute array inside the composite attribute
          if (findIndex !== -1) {
            attributes[findIndex].attribute_values_id.composite = {
              ...attributes[findIndex]?.attribute_values_id?.composite,
              [composite]: value,
            };
          } else {
            // else create a new attribute object with composite attribute
            // value &&
            attributes.push({
              attribute_values_id: {
                attribute_id: attribute,
                composite: { [composite]: value },
              },
            });
          }
        }
        // if attribute is not composite
        else {
          // check if attribute is already in the attributes array
          if (findIndex !== -1) {
            // push the values to existing array
            attributes[findIndex].attribute_values_id.attribute_id = attribute;
            attributes[findIndex].attribute_values_id.values =
              value && typeof value === "object" ? value.join(",") : value;

            if (dtype === "size") {
              const composites =
                attributes[findIndex]?.attribute_values_id?.composite;
              const {
                length = "",
                width = "",
                height = "",
                unit = "",
              } = composites;

              const dimensionMap = {
                length: "L",
                width: "B",
                height: "H",
              };
              let sizeKeys = Object.keys(composites);
              const validSizes = [length, width, height].filter(Boolean) || [];
              const validKeys = sizeKeys.filter(
                (item) => composites[item] && item !== "unit"
              );
              const dimensions =
                validKeys.map((item) => dimensionMap[item]) || [];

              attributes[findIndex].attribute_values_id.values =
                validSizes.length
                  ? `${validSizes.join("x")} ${unit}`.trim()
                  : "";

              attributes[findIndex].attribute_values_id.composite =
                validSizes.length
                  ? attributes[findIndex]?.attribute_values_id?.composite
                  : {};
            }
          } else {
            // else create a new attribute object

            if (value?.comment || value?.fileList) {
              attributes.push({
                attribute_values_id: {
                  attribute_id: attribute,
                  values: value?.comment,
                  composite: value?.fileList,
                },
              });
            } else {
              var temp_value = value || "";
              attributes.push({
                attribute_values_id: {
                  attribute_id: attribute,
                  values:
                    typeof temp_value === "object"
                      ? temp_value.join(",")
                      : temp_value,
                },
              });
            }
          }
        }
      }
    }

    const requestPayload = {
      product_id: values.product_id,
      secondary_category: values.secondary_category,
      attributes,
      product_images: photoList,
      user_id: JSON.parse(userId),
      variants: variantsData || productData?.variants,
      manufacturer: orgId,
      ...(isSubCatPresent ? { sub_category: values.sub_category } : {}),
    };
    console.log("requestPayload", requestPayload);
    console.log("productData", productData);

    if (page === "edit") {
      API_KEY.URL.patch(
        `${API_KEY.path.products}/${productData?.id}`,
        requestPayload
      )
        .then((res) => {
          if (res.status === 200) {
            // if (formData?.secondary_category.id !== categoryId) {
            //   const user = JSON.parse(localStorage.getItem("user"));
            //   axios
            //     .post(
            //       `${process.env.REACT_APP_API_SERVICE}items/productsv2/patch-collection-products-category?id=${productData?.id}&token=${user?.access_token}&categoryId=${categoryId}`,
            //       {}
            //     )
            //     .then((response) => {
            //       setLoadingFinishButton(false);
            //       message.success("Product edited and saved.");
            //       history.replace(`/product-details/${res?.data?.data?.id}`);
            //       sessionStorage.clear();
            //     })
            //     .catch((err) => {
            //       console.log("err:", err);
            //     });
            // } else {
            setLoadingFinishButton(false);
            message.success("Product edited and saved.");
            history.replace(`/product-details/${res?.data?.data?.id}`);
            sessionStorage.clear();
          }
        })
        .catch((err) => {
          console.log(err);
          setLoadingFinishButton(false);
        });
    } else {
      API_KEY.URL.post(API_KEY.path.products, requestPayload)
        .then((res) => {
          if (res.status === 200) {
            setLoadingFinishButton(false);
            message.success("New Product added to Catalogue.");
            // params?.id
            //   ? history.replace(
            //     `/categorywise-products/${params?.name}/${params?.id}`
            //   )
            //   :
            history.replace(`/product-details/${res?.data?.data?.id}`);
            sessionStorage.clear();
          }
        })
        .catch((err) => {
          setLoadingFinishButton(false);
          console.log(err);
        });
    }
  };

  const handleNext = () => {
    setCurrent((parseInt(current) + 1).toString());
  };

  const onFinishFailed = () => {};

  const handleFinish = async (scrollToError) => {
    const values = form.getFieldsValue();

    try {
      const values = await form.validateFields();
      console.log("Success:", values);
    } catch (errorInfo) {
      console.log("Failed:", errorInfo?.errorFields.length > 0);
      if (errorInfo?.errorFields.length > 0) {
        //form.validateFieldsAndScroll();
        scrollToError();
        return;
      }
    }
    // if (!values.product_id && values.product_id !== 0) {
    //   scrollToTop();
    //   return;
    // }
    if (!(photoList?.length > 0)) {
      return;
    }
    onFinish(values);
  };

  const showModalVariant = () => {
    setShowVariantModal(true);
  };

  const handleOkVaraint = (variantsData) => {
    setVariantsData(variantsData);
    setVariantsCount(variantsData.length);
    setShowVariantModal(false);
  };

  const handleCancelVariant = () => {
    setShowVariantModal(false);
  };

  return (
    <Form
      form={form}
      name="onboarding"
      onFinishFailed={onFinishFailed}
      {...formItemLayout}
      style={{ overflow: "hidden" }}
      // scrollToFirstError={true}
    >
      <BreadCrumbComponent page={page} />
      <Row>
        <Col>
          <Title level={4}>
            {page === "edit" ? "Edit Product" : "Add New Product"}
          </Title>
        </Col>
      </Row>

      <VariantModal
        showVariantModal={showVariantModal}
        handleOkVaraint={handleOkVaraint}
        handleCancelVariant={handleCancelVariant}
        attributes={categoryData}
        formData={productData}
        productId={productId}
      />

      <ImageUploadModal
        isModalVisible={isModalVisible}
        handleOk={handleOk}
        handleCancel={handleCancel}
        fileList={fileList}
        setFileList={setFileList}
        previewVisible={previewVisible}
        setPreviewVisible={setPreviewVisible}
        previewImage={previewImage}
        setPreviewImage={setPreviewImage}
        photoList={photoList}
        setphotoList={setphotoList}
        previewTitle={previewTitle}
        setPreviewTitle={setPreviewTitle}
        handlePreview={handlePreview}
        uploadImage={uploadImage}
        handleChangeUpload={handleChangeUpload}
        progress={progress}
        error={error}
        beforeUpload={beforeUpload}
      />

      <Row style={{ marginTop: "1.5rem" }}>
        <Col span={9}>
          <UploadImages
            photoList={photoList}
            showModal={showModal}
            handlePreview={handlePreview}
            uploadImage={uploadImage}
            beforeUpload={beforeUpload}
            handleChangeUpload={handleChangeUpload}
          />
        </Col>

        <Col span={14} offset={1}>
          <StepsComponent
            tabChange={tabChange}
            hideInfo={hideInfo}
            current={current}
            onChangeField={onChangeField}
            getCategoryData={getCategoryData}
            categoryData={categoryData}
            allCategoryData={allCategoryData}
            setAllCategoryData={setAllCategoryData}
            handleClick={handleClick}
            handleFinish={handleFinish}
            handleNext={handleNext}
            showTooltipOnFinish={showTooltipOnFinish}
            page={page}
            loadingFinishButton={loadingFinishButton}
            showModalVariant={showModalVariant}
            variantsData={variantsData}
            variantsCount={variantsCount}
            setProductId={setProductId}
            productId={productId}
            categoryId={categoryId}
            setCategoryId={setCategoryId}
            subcategory={subcategory}
            setSubCategory={setSubCategory}
            setVendorDetailsButton={setVendorDetailsButton}
            showVendorDetails={showVendorDetails}
            showExclusiveDetails={showExclusiveDetails}
            setExclusiveDetailsButton={setExclusiveDetailsButton}
            params={params}
            form={form}
            formData={formData}
            files={files}
            loading={loading}
            sizeUnits={sizeUnit}
            setSizeUnits={setSizeUnit}
          />
        </Col>
      </Row>
    </Form>
  );
}
